import { LeafTag } from "./tag.component.js";
customElements.define("leaf-tag", LeafTag);
export {
  LeafTag
};
//# sourceMappingURL=tag.js.map
